const css = `._box_1blp3_1 {
  align-items: center;
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-spacing: 0;
  color: var(--text-color);
  font-family: inherit;
  gap: 4px;
  justify-content: center;
  line-height: normal;
  position: relative;
  text-decoration: none;
  user-select: none;
}
._box_1blp3_1[data-align=center] {
  align-items: center;
  text-align: center;
}
._box_1blp3_1[data-align=left] {
  align-items: flex-start;
  text-align: left;
}
._box_1blp3_1[data-align=right] {
  align-items: flex-end;
  text-align: right;
}
._box_1blp3_1[data-background=noise] {
  position: relative;
  overflow: hidden;
  z-index: 1;
}
._box_1blp3_1[data-background=noise]::after, ._box_1blp3_1[data-background=noise]::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
._box_1blp3_1[data-background=noise]::after {
  background: var(--noise) transparent no-repeat;
  background-size: cover;
  filter: var(--noise-brightness);
}
._box_1blp3_1[data-background=noise]::before {
  background: var(--noise-background-color);
  filter: blur(101px);
  transform: translate3d(50%, 50%, 0);
  height: 50%;
  width: 50%;
}
._box_1blp3_1[data-background=noise] th,
._box_1blp3_1[data-background=noise] td {
  background-color: transparent;
}
._box_1blp3_1[data-corners=rounded] {
  border-radius: 4px;
  overflow: hidden;
}
._box_1blp3_1[data-corners=circle] {
  border-radius: 50%;
  overflow: hidden;
}
._box_1blp3_1[data-profiling=borderless] {
  border: 0 none transparent;
}
._box_1blp3_1[data-profiling=shadow] {
  border: 0 none transparent;
  box-shadow: var(--box-shadow);
}
._box_1blp3_1[data-size=small] {
  min-width: 16px;
}
._box_1blp3_1[data-size=medium] {
  min-width: 24px;
}
._box_1blp3_1[data-size=large] {
  min-width: 32px;
}
._box_1blp3_1[data-width=auto] {
  width: auto;
}
._box_1blp3_1[data-width=full] {
  box-sizing: border-box;
  width: 100%;
}
._box_1blp3_1[data-width=full]:not(table) {
  display: flex;
}
._box_1blp3_1:is(a, button, input, select)[data-size=small] {
  font-size: 0.7em;
  padding: 4px;
}
._box_1blp3_1:is(a, button, input, select)[data-size=small] svg {
  height: 1em;
  width: 1em;
}
._box_1blp3_1:is(a, button, input, select)[data-size=medium] {
  font-size: 0.8em;
  padding: 12px;
}
._box_1blp3_1:is(a, button, input, select)[data-size=medium] svg {
  height: 16px;
  width: 16px;
}
._box_1blp3_1:is(a, button, input, select)[data-size=large] {
  font-size: 1.2em;
  padding: 16px;
}
._box_1blp3_1:is(a, button, input, select)[data-size=large] svg {
  height: 1em;
  width: 1em;
}
._box_1blp3_1:is(a, button, input, select)[data-width=auto] {
  display: inline-flex;
}
._box_1blp3_1:is(th, td)[data-size=small] {
  font-size: 1em;
  padding: 4px;
}
._box_1blp3_1:is(th, td)[data-size=small] svg {
  height: 1em;
  width: 1em;
}
._box_1blp3_1:is(th, td)[data-size=medium] {
  font-size: 1em;
  padding: 8px;
}
._box_1blp3_1:is(th, td)[data-size=medium] svg {
  height: 1em;
  width: 1em;
}
._box_1blp3_1:is(th, td)[data-size=large] {
  font-size: 1em;
  padding: 16px;
}
._box_1blp3_1:is(th, td)[data-size=large] svg {
  height: 1em;
  width: 1em;
}
._box_1blp3_1:is(a, button) {
  cursor: pointer;
}
._box_1blp3_1:is(a, button) svg {
  fill: currentColor;
}
._box_1blp3_1:is(a, button) svg g {
  fill: currentColor;
}
._box_1blp3_1:is(a, button)._selected_1blp3_151, ._box_1blp3_1:is(a, button):hover {
  --bg-color: var(--button-hover-bg-color);
  --border-color: var(--button-hover-bg-color);
  --text-color: var(--button-hover-text-color);
  transition: all 0.15s ease-in-out;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "box": "_box_1blp3_1",
  "selected": "_selected_1blp3_151"
};